export default {
  GET_LIST_AGENCY: "/WebsiteSTNHD/AgencyList",
  GET_LIST_AGENCY_SEARCH: "/WebsiteSTNHD/AgencyListSearch",
  POST_CREATE_PARTNER: "/WebsiteSTNHD/AgencyRegister",
  GET_NAME: "/Option​/GetList"
}
